module.exports = __webpack_public_path__ + "frontend-assets/img/dummy-coupon.33197e42.png";